import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemePref = 'light' | 'dark' | 'system';

interface ThemeState {
  pref: ThemePref;
  setPref: (pref: ThemePref) => void;
}

function resolveIsDark(pref: ThemePref): boolean {
  if (pref === 'system') return window.matchMedia('(prefers-color-scheme: dark)').matches;
  return pref === 'dark';
}

function applyTheme(pref: ThemePref): void {
  const root = document.documentElement;
  root.classList.toggle('dark', resolveIsDark(pref));
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      pref: 'system',
      setPref: (pref) => {
        applyTheme(pref);
        set({ pref });
      },
    }),
    {
      name: 'wf-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.pref);
      },
    },
  ),
);

if (typeof window !== 'undefined') {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const { pref } = useThemeStore.getState();
    if (pref === 'system') applyTheme('system');
  });
  // Apply immediately on first load (before any component mounts) to avoid a flash.
  applyTheme(useThemeStore.getState().pref);
}
